import Modalheader from "../../../components/header";
import ModalBody from "../../../components/body";
import ModalFooter from "../../../components/footer";
import Button from "../../../../button";
import useModal from "../../../useModal";
import UseContext from "hooks/useContext";
import ApiDatabase from "../../../../../server";
import {toast} from "react-toastify";
import {useEffect, useState, useMemo, useRef} from "react";

const AdminModalMissionUnAssign = () => {
    const {userUnAssigned, setUserUnAssigned, setModalDataReturn} = UseContext()
    const {toggle}=useModal()
    const [loading, setLoading] = useState(false)
    const [isWaiting, setIsWaiting] = useState(false)
    const [reasonUnassigns, setReasonUnassigns] = useState([])
    const [reasonSelected, setReasonSelected] = useState('')
    const [subReasonsSelected, setSubReasonsSelected] = useState([])
    const [isSubReasonsDropdownOpen, setIsSubReasonsDropdownOpen] = useState(false)
    const dropdownRef = useRef(null)
    const token = localStorage.getItem('xsrfToken')

    // Récupérer le motif sélectionné avec ses sous-motifs
    const selectedReason = useMemo(() => {
        return reasonUnassigns.find(r => r._id === reasonSelected)
    }, [reasonSelected, reasonUnassigns])

    // Vérifier si le motif a des sous-motifs
    const hasSubReasons = useMemo(() => {
        return selectedReason?.subReasons && selectedReason.subReasons.length > 0
    }, [selectedReason])

    useEffect(() => {
        if (token) {
            setIsWaiting(true)
            ApiDatabase.getReasonUnassignMission(
                { token },
                (data) => {
                    let reasons = data || []
                    
                    // Si la mission est en cours, ne montrer que le motif "No-show"
                    if (userUnAssigned?.missionStatus === 'in_progress') {
                        reasons = reasons.filter(r => r.name === 'No-show')
                    }
                    
                    setReasonUnassigns(reasons)
                    setIsWaiting(false)
                },
                (err) => {
                    console.log('err', err)
                    setIsWaiting(false)
                }
            )
        }
    }, [token, userUnAssigned?.missionStatus])

    // Réinitialiser les sous-motifs quand le motif change
    useEffect(() => {
        setSubReasonsSelected([])
        setIsSubReasonsDropdownOpen(false)
    }, [reasonSelected])

    // Fermer le dropdown si on clique en dehors
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsSubReasonsDropdownOpen(false)
            }
        }

        if (isSubReasonsDropdownOpen) {
            document.addEventListener('mousedown', handleClickOutside)
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [isSubReasonsDropdownOpen])

    const handleSubReasonToggle = (subReason) => {
        setSubReasonsSelected(prev => {
            if (prev.includes(subReason)) {
                return prev.filter(sr => sr !== subReason)
            } else {
                return [...prev, subReason]
            }
        })
    }

    const handleUnAssign = () => {
        setUserUnAssigned({})
        setReasonSelected('')
        setSubReasonsSelected([])
        setIsSubReasonsDropdownOpen(false)
        toggle()
    }

    const unAssignMission = () => {
        if(userUnAssigned && reasonSelected){
            if(userUnAssigned.idMission && userUnAssigned.userAssigned){
                setLoading(true)
                ApiDatabase.unassignMission({
                    token: token, 
                    idMission: userUnAssigned.idMission, 
                    userAssigned: userUnAssigned.userAssigned,
                    reason: reasonSelected,
                    subReasons: subReasonsSelected.length > 0 ? subReasonsSelected : null
                }, async (data) => {
                    toast.success('La mission a bien été désassignée')
                    setUserUnAssigned({})
                    setReasonSelected('')
                    setSubReasonsSelected([])
                    setIsSubReasonsDropdownOpen(false)
                    setModalDataReturn('mission unassigned')
                    toggle()
                }, (err) => {
                    toast.error('Une erreur est survenue lors de la désassignation de la mission : ' + err.response?.data?.error)
                    setLoading(false)
                })
            } else {
                toast.error('Une erreur est survenue lors de la désassignation de la mission')
            }
        } else {
            toast.error('Veuillez sélectionner un motif de désassignation')
        }
    }

    return (
        <>
            <Modalheader hide={handleUnAssign} hideShow={true}>
                Désattribuer la mission
            </Modalheader>
            <ModalBody>
                {isWaiting ? (
                    <div className="text-center py-4">Chargement ...</div>
                ) : (
                    <div className="flex flex-col gap-4">
                        <p>Êtes-vous sûr de vouloir dés-attribuer cette mission ?</p>
                        <div>
                            <label className="ft-sm text-gray-500">
                                <div className="mb-1">Motif de désattribution</div>
                                <select
                                    className="w-full h-10 pl-3 pr-8 ft-b border rounded-lg text-gray-900"
                                    value={reasonSelected}
                                    onChange={(e) => setReasonSelected(e.target.value)}
                                >
                                    <option value="">Sélectionnez un motif</option>
                                    {reasonUnassigns.map((reason, index) => (
                                        <option key={index} value={reason._id}>
                                            {reason.name}
                                        </option>
                                    ))}
                                </select>
                            </label>
                        </div>

                        {/* Select dropdown pour les sous-motifs */}
                        {hasSubReasons && (
                            <div className="relative" ref={dropdownRef}>
                                <label className="ft-sm text-gray-500">
                                    <div className="mb-1">Précisez le(s) motif(s)</div>
                                    <div 
                                        className="w-full h-10 pl-3 pr-8 ft-b border rounded-lg text-gray-900 bg-white cursor-pointer flex items-center justify-between"
                                        onClick={() => setIsSubReasonsDropdownOpen(!isSubReasonsDropdownOpen)}
                                    >
                                        <span className={subReasonsSelected.length > 0 ? 'text-gray-900' : 'text-gray-400'}>
                                            {subReasonsSelected.length > 0 
                                                ? `${subReasonsSelected.length} motif(s) sélectionné(s)`
                                                : 'En savoir plus'
                                            }
                                        </span>
                                        <svg 
                                            className={`w-5 h-5 text-gray-400 transition-transform ${isSubReasonsDropdownOpen ? 'rotate-180' : ''}`}
                                            fill="none" 
                                            stroke="currentColor" 
                                            viewBox="0 0 24 24"
                                        >
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                        </svg>
                                    </div>
                                </label>

                                {/* Dropdown avec checkboxes */}
                                {isSubReasonsDropdownOpen && (
                                    <div className="absolute z-[9999] w-full bottom-full mb-1 bg-white border border-gray-300 rounded-lg shadow-xl max-h-60 overflow-y-auto">
                                        <div className="p-2">
                                            {selectedReason.subReasons.map((subReason, index) => (
                                                <label 
                                                    key={index} 
                                                    className="flex items-start gap-3 cursor-pointer hover:bg-gray-50 p-2 rounded-md transition-colors"
                                                >
                                                    <input
                                                        type="checkbox"
                                                        className="mt-0.5 w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 cursor-pointer"
                                                        checked={subReasonsSelected.includes(subReason)}
                                                        onChange={() => handleSubReasonToggle(subReason)}
                                                    />
                                                    <span className="text-sm text-gray-700">
                                                        {subReason}
                                                    </span>
                                                </label>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                )}
            </ModalBody>
            <ModalFooter>
                {loading ? (
                  <>
                      <Button size={'LG'} color={'DISABLED'}>Annuler</Button>
                      <Button size={'LG'} color={'DISABLED'}>Dés-attribution de la mission...</Button>
                  </>
                ) : (
                  <>
                      <Button size={'LG'} color={'SECONDARY'} onClick={handleUnAssign}>Annuler</Button>
                      <Button size={'LG'} onClick={unAssignMission} disabled={!reasonSelected}>Confirmer</Button>
                  </>
                )}
            </ModalFooter>
        </>
    )
}

export default AdminModalMissionUnAssign